import React from 'react';
import Link from 'gatsby-link';
import './from-the-blog.scss';
import lettuce from '../assets/images/lettuce-grow-urban-farming.png';
import fishing from '../assets/images/lettuce-grow-fishing-sustainable.jpg';

export default class FromTheBlog extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="from-the-blog">
                <figure className="from-the-blog__title">
                    From The <span>Blog</span>
                </figure>
                <div className="from-the-blog__content">
                    {this.props.data.edges.map(({ node }, i) => {
                        return (
                            <div key={i}>
                                <Link to={`/blog/${node.slug}`} className="from-the-blog__read-more">
                                    <figure
                                        className="from-the-blog__image"
                                        style={
                                            node.heroImage && node.heroImage.file
                                                ? {
                                                      backgroundImage: `url(${node.heroImage.file
                                                          .url}?fm=jpg&q=80&w=800&h=800&fl=progressive&fit=thumb&f=face`,
                                                  }
                                                : {}
                                        }
                                    >
                                        <div className="from-the-blog__tag">
                                            {node.category ? node.category.title : ''}
                                        </div>
                                    </figure>
                                </Link>
                                <div className="from-the-blog__text">
                                    <h3 className="from-the-blog__headline">
                                        {node.title}
                                    </h3>
                                    <p className="from-the-blog__copy">
                                        {node.introductoryQuote ? node.introductoryQuote.introductoryQuote : ''}
                                    </p>
                                    <Link to={`/blog/${node.slug}`} className="from-the-blog__read-more">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/from-the-blog.js